import { remove } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { invalidateWorkplaceChargeLeadTimeDifferentialsQueries } from "./invalidateWorkplaceChargeLeadTimeDifferentialsQueries";

interface DeleteWorkplaceChargeLeadTimeDifferentialParams {
  workplaceId: string;
  differentialId: string;
}

export function useDeleteWorkplaceChargeLeadTimeDifferential() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: DeleteWorkplaceChargeLeadTimeDifferentialParams) => {
      const { workplaceId, differentialId } = params;
      const url = `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/charge-lead-time-differentials/${differentialId}`;

      await remove({
        url,
        responseSchema: z.object({}),
      });
    },
    onSuccess: (_, variables) => {
      invalidateWorkplaceChargeLeadTimeDifferentialsQueries(queryClient, variables.workplaceId);
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.DELETE_WORKPLACE_CHARGE_LEAD_TIME_DIFFERENTIAL_FAILURE,
    },
  });
}
